export const JOBS = [
  {
    id: "php-developer",
    slug: "php-developer",
    title: "PHP Developer",
    experience: "1+ Years",
    location: "Pune, India",
    employmentType: "FULL_TIME",
    summary:
      "We are looking for a skilled PHP Developer to join our development team. You will be responsible for developing, maintaining and enhancing web applications and backend systems. The ideal candidate has strong PHP fundamentals, OOP knowledge, MVC framework experience and the ability to develop clean, scalable, maintainable code.",
    responsibilities: [
      "Develop and maintain web applications using PHP.",
      "Work with Core PHP and PHP frameworks such as Laravel.",
      "Develop REST APIs and third-party integrations.",
      "Follow object-oriented programming principles and design patterns.",
      "Work with MySQL and relational databases.",
      "Troubleshoot and resolve application issues.",
      "Develop and customize CMS-based applications.",
      "Write clean, optimized and maintainable code.",
      "Collaborate with frontend developers, designers and QA engineers.",
      "Participate in code reviews and technical discussions.",
    ],
    skills: [
      "PHP",
      "Core PHP",
      "Laravel or other PHP frameworks",
      "OOP",
      "MVC",
      "MySQL",
      "HTML5",
      "CSS3",
      "JavaScript",
      "jQuery",
      "AJAX",
      "REST APIs",
      "Git",
    ],
  },
  {
    id: "nodejs-developer",
    slug: "nodejs-developer",
    title: "Node.js Developer",
    experience: "1+ Years",
    location: "Pune, India",
    employmentType: "FULL_TIME",
    summary:
      "We are looking for a Node.js Developer to build and maintain scalable backend applications, APIs, integrations and server-side systems. The ideal candidate should have strong JavaScript knowledge, experience with asynchronous programming, REST APIs, databases and backend architecture.",
    responsibilities: [
      "Develop backend applications using Node.js.",
      "Build and maintain RESTful APIs.",
      "Develop scalable server-side applications.",
      "Work with MongoDB, MySQL or PostgreSQL.",
      "Integrate third-party APIs and services.",
      "Implement authentication and authorization.",
      "Optimize backend performance.",
      "Troubleshoot and resolve technical issues.",
      "Write clean and maintainable code.",
      "Collaborate with frontend developers and QA engineers.",
    ],
    skills: [
      "Node.js",
      "JavaScript",
      "Express.js",
      "REST APIs",
      "MongoDB",
      "MySQL/PostgreSQL",
      "Async programming",
      "API integrations",
      "Git",
      "JSON",
      "Webhooks",
    ],
  },
  {
    id: "react-developer",
    slug: "react-developer",
    title: "React Developer",
    experience: "1+ Years",
    location: "Pune, India",
    employmentType: "FULL_TIME",
    summary:
      "We are looking for a React Developer who can build modern, responsive and high-performance web applications. The candidate should have strong knowledge of React.js, JavaScript, component-based architecture, API integration and responsive frontend development.",
    responsibilities: [
      "Develop responsive web applications using React.",
      "Build reusable React components.",
      "Integrate REST APIs.",
      "Manage application state.",
      "Implement responsive UI designs.",
      "Optimize frontend performance.",
      "Debug and troubleshoot frontend issues.",
      "Work closely with UI/UX designers and backend developers.",
      "Follow clean coding and component architecture practices.",
    ],
    skills: [
      "React.js",
      "JavaScript",
      "HTML5",
      "CSS3",
      "REST APIs",
      "Responsive Design",
      "Bootstrap or similar frameworks",
      "Git",
      "JSON",
      "API Integration",
    ],
  },
  {
    id: "ui-frontend-developer",
    slug: "ui-frontend-developer",
    title: "UI / Frontend Developer",
    experience: "1+ Years",
    location: "Pune, India",
    employmentType: "FULL_TIME",
    summary:
      "We are looking for a UI / Frontend Developer responsible for converting designs into modern, responsive and high-quality web interfaces. The candidate should have strong HTML, CSS, JavaScript and responsive web development skills with an eye for detail and user experience.",
    responsibilities: [
      "Convert UI/UX designs into responsive websites.",
      "Develop modern and reusable frontend components.",
      "Ensure cross-browser compatibility.",
      "Optimize websites for performance.",
      "Build responsive desktop and mobile interfaces.",
      "Work with designers and backend developers.",
      "Implement animations and interactive elements.",
      "Troubleshoot UI and frontend issues.",
    ],
    skills: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "jQuery",
      "Bootstrap",
      "Responsive Web Design",
      "Cross-browser compatibility",
      "UI implementation",
      "Git",
    ],
  },
  {
    id: "quality-analyst",
    slug: "quality-analyst",
    title: "Quality Analyst",
    experience: "1+ Years",
    location: "Pune, India",
    employmentType: "FULL_TIME",
    summary:
      "We are looking for a Quality Analyst responsible for ensuring the quality, reliability, usability and performance of web applications and software solutions. The candidate should have experience with manual testing and preferably automation testing.",
    responsibilities: [
      "Perform functional and regression testing.",
      "Perform integration and system testing.",
      "Test web applications across browsers and devices.",
      "Create test cases and test scenarios.",
      "Analyze requirements and identify potential issues.",
      "Report, track and verify defects.",
      "Perform UI and usability testing.",
      "Work closely with developers to reproduce and resolve bugs.",
      "Prepare test reports and documentation.",
      "Participate in release testing and quality assurance processes.",
    ],
    skills: [
      "Manual Testing",
      "Functional Testing",
      "Regression Testing",
      "Integration Testing",
      "System Testing",
      "Web Application Testing",
      "Test Case Design",
      "Bug Tracking",
      "API Testing",
      "Browser Testing",
      "Basic Automation Testing (plus)",
    ],
  },
];
